import { render } from "./BaseModal.vue?vue&type=template&id=4ea648be"
import script from "./BaseModal.vue?vue&type=script&lang=ts"
export * from "./BaseModal.vue?vue&type=script&lang=ts"
script.render = render

export default script